import { useQueryClient } from '@tanstack/react-query';
import { contactsKeys } from './keys';
import { Capacitor } from '@capacitor/core';
import { Contact } from '../../services/contacts-manager';
import { getContacts } from './api';

export const useContactsQueries = () => {
	const queryClient = useQueryClient();
	const contactsQuery = () => ({
		refetchOnReconnect: false,
		queryKey: contactsKeys.all(),
		queryFn: async () => {
			if (Capacitor.isNativePlatform()) {
				return queryClient.getQueryData<Contact[]>(contactsKeys.all()) ?? [];
			} else {
				return await getContacts();
			}
		},
	});

	return {
		contactsQuery,
	};
};
